import { OrgRole, isOrgRoleSuperset } from "@hex/common";
import React from "react";

import { HexMenuItem } from "../../../hex-components/HexMenuItem.js";
import { useCurrentUser } from "../../../hooks/me/useCurrentUser.js";
import { useHexFlag } from "../../../util/useHexFlags.js";
import {
  ChartCellIcon,
  ExploreIcon,
  PivotCellIcon,
  TableCellIcon,
} from "../../icons/CustomIcons.js";

export const getDataBrowserMenuText = (cellType: string): string => {
  return `${cellType} cell`;
};

interface DataBrowserMenuItemsProps {
  createDisplayTableCell: () => void;
  createChartCell: () => void;
  createPivotCell: () => void;
  createExploreCell?: () => void;
  prefix?: string;
}

export const DataBrowserMenuItems: React.ComponentType<DataBrowserMenuItemsProps> =
  React.memo(function DataBrowserMenuItems({
    createChartCell,
    createDisplayTableCell,
    createExploreCell,
    createPivotCell,
  }) {
    const exploreBackedCharts = useHexFlag("explore-backed-charts");
    const orgRole = useCurrentUser()?.orgRole;
    const showExploreOption =
      orgRole &&
      isOrgRoleSuperset(orgRole, OrgRole.EDITOR) &&
      !exploreBackedCharts;
    return (
      <>
        {showExploreOption && createExploreCell && (
          <HexMenuItem
            icon={<ExploreIcon />}
            text={getDataBrowserMenuText("Explore")}
            onClick={createExploreCell}
          />
        )}
        <HexMenuItem
          icon={<ChartCellIcon />}
          text={getDataBrowserMenuText("Chart")}
          onClick={createChartCell}
        />
        <HexMenuItem
          icon={<TableCellIcon />}
          text={getDataBrowserMenuText("Table")}
          onClick={createDisplayTableCell}
        />

        <HexMenuItem
          icon={<PivotCellIcon />}
          text={getDataBrowserMenuText("Pivot")}
          onClick={createPivotCell}
        />
      </>
    );
  });
